module.exports = __webpack_public_path__ + "media/new/approve_step_1-66b2624d.png";